import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery, saveToCookies } from '../utils';

export const api = createApi({
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    login: builder.mutation<any, any>({
      query: (credentials) => ({
        url: '/auth/admin/login',
        method: 'POST',
        body: credentials,
        responseHandler(response: any) {
          if (response.ok) {
            response.json().then((data: any) => {
              saveToCookies('at', data.jwtToken);
            });
            return response;
          }
          return response.json().then((data: any) => {
            return data;
          });
        },
      }),
    }),
  }),
});

export const { useLoginMutation } = api;
